import React from 'react'
import { Link } from 'gatsby'
import { Layout, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        state="develop"
        slug={data.slug + '/develop/'}
        title={data.title}
      />
      <Layout
        category={data.category}
        changelog={changelog[data.title].changelog}
        description={data.description}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        ## Variants
        <Showcase
          site={data.site}
          title="Date Select"
          text={
            <p>
              In addition to the default state, each selectable element of the
              date select bar also has an active state, a focus state and a
              selected state. In the active state, a dropdown presents input
              options with their own hover states. Once the user selects an
              option, the dropdown disappears, and the selected state appears
              for that element. The error state takes the form of an{' '}
              <Link
                to={`${data.site}/components/inline-error/develop/`}
                className="c-link"
              >
                Input Error
              </Link>{' '}
              component.
            </p>
          }
          code={code.checkbox}
        >
          <div class="c-date">
            <div class="c-date__icon-container">
              <i class="c-date__icon icon icon--calendar"></i>
            </div>
            <select class="c-date__month">
              <option value="">Month</option>
              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
            <select class="c-date__day">
              <option value="">Day</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
              <option value="21">21</option>
              <option value="22">22</option>
              <option value="23">23</option>
              <option value="24">24</option>
              <option value="25">25</option>
              <option value="26">26</option>
              <option value="27">27</option>
              <option value="28">28</option>
              <option value="29">29</option>
              <option value="30">30</option>
              <option value="31">31</option>
            </select>
            <select class="c-date__year">
              <option value="">Year</option>
              <option value="i+2017">2018</option>
              <option value="i+2017">2019</option>
              <option value="i+2017">2020</option>
              <option value="i+2017">2021</option>
              <option value="i+2017">2022</option>
              <option value="i+2017">2023</option>
              <option value="i+2017">2024</option>
              <option value="i+2017">2025</option>
              <option value="i+2017">2026</option>
              <option value="i+2017">2027</option>
              <option value="i+2017">2028</option>
              <option value="i+2017">2029</option>
              <option value="i+2017">2030</option>
              <option value="i+2017">2031</option>
              <option value="i+2017">2032</option>
              <option value="i+2017">2033</option>
              <option value="i+2017">2034</option>
              <option value="i+2017">2035</option>
              <option value="i+2017">2036</option>
              <option value="i+2017">2037</option>
            </select>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="International Date Select"
          text={
            <p>
              This International Date Select offers the same functionality of
              the default in a widely recognized international date format
              (DD/MM/YYYY). The states in the International Date Select function
              identically to the default.
            </p>
          }
          code={code.international}
        >
          <div class="c-date">
            <div class="c-date__icon-container">
              <i class="c-date__icon icon icon--calendar"></i>
            </div>
            <select class="c-date__day">
              <option value="">Day</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
              <option value="21">21</option>
              <option value="22">22</option>
              <option value="23">23</option>
              <option value="24">24</option>
              <option value="25">25</option>
              <option value="26">26</option>
              <option value="27">27</option>
              <option value="28">28</option>
              <option value="29">29</option>
              <option value="30">30</option>
              <option value="31">31</option>
            </select>
            <select class="c-date__month">
              <option value="">Month</option>
              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
            <select class="c-date__year">
              <option value="">Year</option>
              <option value="i+2017">2018</option>
              <option value="i+2017">2019</option>
              <option value="i+2017">2020</option>
              <option value="i+2017">2021</option>
              <option value="i+2017">2022</option>
              <option value="i+2017">2023</option>
              <option value="i+2017">2024</option>
              <option value="i+2017">2025</option>
              <option value="i+2017">2026</option>
              <option value="i+2017">2027</option>
              <option value="i+2017">2028</option>
              <option value="i+2017">2029</option>
              <option value="i+2017">2030</option>
              <option value="i+2017">2031</option>
              <option value="i+2017">2032</option>
              <option value="i+2017">2033</option>
              <option value="i+2017">2034</option>
              <option value="i+2017">2035</option>
              <option value="i+2017">2036</option>
              <option value="i+2017">2037</option>
            </select>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  checkbox: `<div class="c-date">
    <div class="c-date__icon-container">
        <i class="c-date__icon icon icon--calendar"></i>
    </div>
    <select class="c-date__month">
        <option value="">Month</option>
        <option value="1">January</option>
        <option value="2">February</option>
        <option value="3">March</option>
        <option value="4">April</option>
        <option value="5">May</option>
        <option value="6">June</option>
        <option value="7">July</option>
        <option value="8">August</option>
        <option value="9">September</option>
        <option value="10">October</option>
        <option value="11">November</option>
        <option value="12">December</option>
    </select>
    <select class="c-date__day">
        <option value="">Day</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
        <option value="13">13</option>
        <option value="14">14</option>
        <option value="15">15</option>
        <option value="16">16</option>
        <option value="17">17</option>
        <option value="18">18</option>
        <option value="19">19</option>
        <option value="20">20</option>
        <option value="21">21</option>
        <option value="22">22</option>
        <option value="23">23</option>
        <option value="24">24</option>
        <option value="25">25</option>
        <option value="26">26</option>
        <option value="27">27</option>
        <option value="28">28</option>
        <option value="29">29</option>
        <option value="30">30</option>
        <option value="31">31</option>
    </select>
    <select class="c-date__year">
        <option value="">Year</option>
        <option value="i+2017">2018</option>
        <option value="i+2017">2019</option>
        <option value="i+2017">2020</option>
        <option value="i+2017">2021</option>
        <option value="i+2017">2022</option>
        <option value="i+2017">2023</option>
        <option value="i+2017">2024</option>
        <option value="i+2017">2025</option>
        <option value="i+2017">2026</option>
        <option value="i+2017">2027</option>
        <option value="i+2017">2028</option>
        <option value="i+2017">2029</option>
        <option value="i+2017">2030</option>
        <option value="i+2017">2031</option>
        <option value="i+2017">2032</option>
        <option value="i+2017">2033</option>
        <option value="i+2017">2034</option>
        <option value="i+2017">2035</option>
        <option value="i+2017">2036</option>
        <option value="i+2017">2037</option>
    </select>
</div>
`,
  international: `<div class="c-date">
    <div class="c-date__icon-container">
        <i class="c-date__icon icon icon--calendar"></i>
    </div>
    <select class="c-date__day">
        <option value="">Day</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
        <option value="13">13</option>
        <option value="14">14</option>
        <option value="15">15</option>
        <option value="16">16</option>
        <option value="17">17</option>
        <option value="18">18</option>
        <option value="19">19</option>
        <option value="20">20</option>
        <option value="21">21</option>
        <option value="22">22</option>
        <option value="23">23</option>
        <option value="24">24</option>
        <option value="25">25</option>
        <option value="26">26</option>
        <option value="27">27</option>
        <option value="28">28</option>
        <option value="29">29</option>
        <option value="30">30</option>
        <option value="31">31</option>
    </select>
    <select class="c-date__month">
        <option value="">Month</option>
        <option value="1">January</option>
        <option value="2">February</option>
        <option value="3">March</option>
        <option value="4">April</option>
        <option value="5">May</option>
        <option value="6">June</option>
        <option value="7">July</option>
        <option value="8">August</option>
        <option value="9">September</option>
        <option value="10">October</option>
        <option value="11">November</option>
        <option value="12">December</option>
    </select>
    <select class="c-date__year">
        <option value="">Year</option>
        <option value="i+2017">2018</option>
        <option value="i+2017">2019</option>
        <option value="i+2017">2020</option>
        <option value="i+2017">2021</option>
        <option value="i+2017">2022</option>
        <option value="i+2017">2023</option>
        <option value="i+2017">2024</option>
        <option value="i+2017">2025</option>
        <option value="i+2017">2026</option>
        <option value="i+2017">2027</option>
        <option value="i+2017">2028</option>
        <option value="i+2017">2029</option>
        <option value="i+2017">2030</option>
        <option value="i+2017">2031</option>
        <option value="i+2017">2032</option>
        <option value="i+2017">2033</option>
        <option value="i+2017">2034</option>
        <option value="i+2017">2035</option>
        <option value="i+2017">2036</option>
        <option value="i+2017">2037</option>
    </select>
</div>
`,
}
